


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Product } from "@/model/product/Product";
import SwitchToggle from "@/components/SwitchToggle.vue";
import dayjs from "dayjs";
import { EventBus } from "@/helpers/EventBus";
import { SalesCapacity } from "@/model/product/SalesCapacity";
import authentication from "@/configuration/authentication";
import { Traceability } from "@/model/product/Traceability";
import { ZoneCodeConstants,ProductionTypeConstants } from "@/model/product/ProductConstants";

@Component({
    components: { SwitchToggle }
})
export default class CapacityProductPanel extends Vue {

    @Prop({}) keyToUpdate: number;
    @Prop({}) product: Product;
    @Prop({}) traceability: Traceability;

    public FISHMONGER_ZONECODE: string = ZoneCodeConstants.FISHMONGER;
    public productOrigin: string = null;
    public isOutOfStock: boolean = false;

    created() {
        this.setupComponent();
    }

    get isFishProduct() {
        return this.product.zoneCode === this.FISHMONGER_ZONECODE;
    }

    get isWildFishProduct() {
        return this.product.fishingOrigin.productionType === ProductionTypeConstants.WILD;
    }

    get isBreedingFishProduct() {
        return this.product.fishingOrigin.productionType === ProductionTypeConstants.BREEDING;
    }

    isBreakActivated(outofStockDate: Date) {
        return dayjs(outofStockDate).isSame(dayjs(), 'day');
    }

    setLastOutOfStockDate() {
        this.isOutOfStock = true;
        EventBus.$emit(EventBus.UPDATE_PRODUCT_OUT_OF_STOCK_STATUS, this.product);
    }

    setOrigin() {
        EventBus.$emit(EventBus.UPDATE_ORIGIN, this.productOrigin, this.product);
    }

    selectProduct() {
        if(this.canAccessProductData){
            EventBus.$emit(EventBus.UPDATE_SELECTED_PRODUCT, this.product);
        }
    }

    @Watch("keyToUpdate")
    setupComponent() {
        this.productOrigin = this.product.origin;
        this.isOutOfStock = this.isBreakActivated(this.product.lastOutOfStockDate);
    }

    getDayCapacity(){
        if (this.product.weeklyCapacity == null) {
            return 0;
        }
        const dayCapacity: SalesCapacity = this.product.weeklyCapacity.find(x => x.dayOfWeek.toUpperCase() === dayjs().locale('en').format('dddd').toUpperCase())
        if (dayCapacity == null || (dayCapacity.quantity == null && !dayCapacity.isUnlimited)) {
            return 0;
        }
        return dayCapacity.isUnlimited ? "Illimité" : dayCapacity.quantity;
    }

    get canAccessProductData() {
        const userRights = authentication.userRights();
        return userRights && 
        (userRights.role === 'CENTRAL_ADMIN' 
        || userRights.role === 'STORE_ADMIN'
        || userRights.role === 'MANAGER');
    }

    get allOrigins(): string[] {
        if (this.traceability == null) {
            return [];
        }

        return this.traceability.origins;
    }
}
